import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { chakra, useMultiStyleConfig } from "@chakra-ui/react";
export const InfoBox = ({ children, variant = "primary", icon, isChat, ...props }) => {
    const styles = useMultiStyleConfig("InfoBox", { variant });
    const borderTopLeftRadius = isChat ? 0 : "lg";
    return (_jsxs(chakra.div, { "data-testid": "infobox", __css: styles.container, borderTopLeftRadius: borderTopLeftRadius, ...props, children: [icon && _jsx(chakra.div, { __css: styles.icon, children: icon }), _jsx(chakra.div, { flex: 1, children: children })] }));
};
